import { Navigate, Routes, Route } from "react-router-dom"

import "../styles/PrivateOutlet.css"

import OrderDining from "../components/orders/OrderDining"
import OrderCatering from "../components/orders/OrderCatering"
import Admin from "../components/orders/Admin"
import Ticket from "../components/orders/Ticket"

function PrivateOutlet({ user }) {
  const token = localStorage.getItem("token")

  if (!token || token === "undefined" || token === null) {
    return <Navigate replace to="/register" />
  }
  
  return (
    <>
      <Routes>
        <Route path="dining" element={<OrderDining user={user} />} />
        <Route path="catering" element={<OrderCatering user={user} />} />

        <Route path="admin" element={<Admin user={user} />} />
        <Route path="admin/:order_id/:order_number" element={<Ticket user={user} />} />
      </Routes>      
    </>
  )
}

export default PrivateOutlet
